__webpack_require__.p = "/ukrainian/";